module.exports = __webpack_public_path__ + "static/media/background.0ab623fb.png";